var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C6.89421 2.75 2.75 6.89421 2.75 12C2.75 17.1058 6.89421 21.25 12 21.25C17.1058 21.25 21.25 17.1058 21.25 12C21.25 6.89421 17.1058 2.75 12 2.75ZM1.25 12C1.25 6.06579 6.06579 1.25 12 1.25C17.9342 1.25 22.75 6.06579 22.75 12C22.75 17.9342 17.9342 22.75 12 22.75C6.06579 22.75 1.25 17.9342 1.25 12ZM11.63 6.76001C12.0442 6.76001 12.38 7.0958 12.38 7.51001V11.61C12.38 11.7636 12.4386 11.9861 12.569 12.2147C12.6994 12.4434 12.861 12.607 12.9924 12.6848L12.9943 12.686L16.0943 14.536C16.45 14.7482 16.5663 15.2087 16.354 15.5644C16.1418 15.92 15.6814 16.0363 15.3257 15.824L12.2277 13.9752L12.2266 13.9746C11.8185 13.7324 11.4904 13.3513 11.266 12.9578C11.0414 12.5639 10.88 12.0865 10.88 11.61V7.51001C10.88 7.0958 11.2158 6.76001 11.63 6.76001Z",
    fill: "#515E5F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.c7c51c95ddb5e5c50a47750006b11c39.svg";
export { ForwardRef as ReactComponent };